import { Directive, ElementRef, HostListener, inject, output } from '@angular/core';

@Directive({
  selector: '[rcClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  clickOutside = output<void>();
  #elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement): void {
    const ne = this.#elementRef.nativeElement;

    // Check if click is inside the host element
    const clickedInsideHost = ne.contains(target);

    // Check if click is inside any Kendo popup (which are rendered at root)
    const clickedInsidePopup = !!target.closest('kendo-popover');

    if (!clickedInsideHost && !clickedInsidePopup) {
      this.clickOutside.emit();
    }
  }
}
